'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getTags()
  }

  getTags() {
    let params = {};
    this.$http.get('/api/tags', { params: params }).then(response => {
      this.tags = response.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete('/api/tags/' + id).then(response => {
        this.getTags();
      });
    }
  }

  addTag() {
    if (!this.name.trim()) {
        alert("名称不能为空")
    }
    let data = {
      name: this.name
    };
    this.$http.post('/api/tags', data).then(res => {
      this.getTags();
    })
  }

}



// WEBPACK FOOTER //
// ./client/app/tags/list/list.controller.js